import { render, staticRenderFns } from "./holiday-filter.vue?vue&type=template&id=a4efa142"
import script from "./holiday-filter.vue?vue&type=script&lang=js"
export * from "./holiday-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports